module.exports = __webpack_public_path__ + "static/media/opensanshebrew-bold.d08650b7.woff";